  const http = 'http://118.195.158.30:10100'//接口地址ip
// const http = 'http://192.168.0.218:6600'

// 创建uuid
const uuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
       var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
       return v.toString(16);
    });
}

// 获取当前日期时间
const nowTime = function () {
    var date = new Date(),
       year = date.getFullYear(),
       month = date.getMonth() + 1,
       day = date.getDate(),
       hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
       minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
       second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    month >= 1 && month <= 9 ? (month = "0" + month) : "";
    day >= 0 && day <= 9 ? (day = "0" + day) : "";
    var timer = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    return timer;
};


//以上创建的方法都要在这里进行注册
export default {
    http,
    uuid,
    nowTime,
    open
}


// WEBPACK FOOTER //
// ./src/utils/public.js